export default {
	title: 'temperature_actions',
	components: [{ title: 'temperature_actions', component: 'temperature_actions' }],
};
